import { useEffect, useState } from "react";
import { Pagination, PaginationSectionWrapper, RowCountSwitch } from "../../../components/Pagination";
import { Loading } from "../../../components/ui/loading";
import { ResourceLoadingError } from "../../../components/ui/resource-loading-error";
import Workspace from "../../../components/workspace/index.jsx";
import memberService from "./member-service";
import { Members } from "./members.jsx";
import { useMembership } from "./membership-state-manager";

const MembersListContainer = ({ search = "", page, setPage, filters }) => {
   const [members, setMembers] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [errorMessage, setErrorMessage] = useState();
   const [rows, setRows] = useState(10);
   const [totalPages, setTotalPages] = useState(1);

   const { membershipLevels } = useMembership();

   useEffect(() => {
      const loadMembers = async () => {
         setIsLoading(true);

         try {
            const fetchResult = await memberService.getMembers({
               page,
               rows,
               search,
               filters,
            });
            setMembers(fetchResult.data);
            setTotalPages(fetchResult.totalPages);
         } catch (error) {
            setErrorMessage(error.message);
         } finally {
            setIsLoading(false);
         }
      };
      loadMembers();
      return () => {
         setErrorMessage(null);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [page, rows, search, filters]);

   if (isLoading) return <Loading />;
   if (errorMessage) return <ResourceLoadingError error={errorMessage} />;

   return (
      <Workspace.List>
         <Members membershipLevels={membershipLevels} membersList={members} setMembers={setMembers} />
         <PaginationSectionWrapper>
            <RowCountSwitch setRows={setRows} rows={rows} />
            {members.length ? <Pagination setPage={setPage} page={page} totalPages={totalPages} /> : null}
         </PaginationSectionWrapper>
      </Workspace.List>
   );
};

export default MembersListContainer;
